export default __webpack_public_path__ + "static/media/ball.efde440e.png";